export const statuses = {
  in_progress: {
    name: 'in_progress',
    title: 'در انتظار پرداخت',
    class: 'inprogress-order',
  },
  failed: {
    name: 'failed',
    title: 'پرداخت ناموفق',
    class: 'cancled-order',
  },
  successful: {
    name: 'successful',
    title: 'تحویل کالا',
    class: 'success-order',
  },
  pending: {
    name: 'pending',
    title: 'در حال آماده سازی',
    class: 'inprogress-order',
  },
  posted: {
    name: 'posted',
    title: 'ارسال شده',
    class: 'inprogress-order',
  },
  canceled: {
    name: 'canceled',
    title: 'لغو شده',
    class: 'cancled-order',
  },
  sepidar: {
    name: 'sepidar',
    title: 'ارسال به سپیدار',
    class: '',
  },
};
